import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import TopPanel from "../../components/Customers/TopFilterBtn/TopFilterBtn";

import { interfaceActions } from "../../../../common/redux/actions";
import * as filtersActions from "../../redux/actions/filtersActions";
import * as customersActions from "../../redux/actions/customers";

import * as URLs from "../../../../common/constants/systemUrls";
import CustomersTable from "../../components/Customers/Table/Table";
import { Avatar, Typography, Button } from "antd";
import moment from "moment";
import "./Customers.css";
import { ADD_CUSTOMER } from "../../../../common/constants/systemUrls";
import EmployeeImage from "../../../../common/images/svg/Employee.svg";
import { debounce } from "lodash";

const { setCaption } = interfaceActions;
const { getAllCustomers } = customersActions;
const {
  updateFilterFieldsCustomers,
  searchCustomers,
  changeTypeListCustomers,
  resetFiltersCustomers
} = filtersActions;

const { Text } = Typography;

class Customers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerVisible: false,
      drawerCols: {
        customer: true,
        balance: true,
        data: true,
        orders: true,
        price: false,
        routeLength: false,
        dateApplication: false,
        placeDelivery: false,
        settlementForm: false,
        driver: false,
        finalDestination: false,
        dateCreation: false,
        statusSendingACBDPL: false,
        sendingTrafficPolice: false
      },
      tableColumnsLen: 0,
      pagination: {
        pages: 5
      },
      customers: []
    };

    this.getAllCustomersDebounced = debounce(this.props.getAllCustomers, 1000);
  }

  componentDidMount() {
    this.props.setCaption({
      enabled: true,
      mainCaption: "Заказчики",
      breadCrumbs: [
        { path: "/" + URLs.CONTROL_PANEL, breadcrumbName: "Панель управления" },
        { path: "/" + URLs.CUSTOMERS, breadcrumbName: "Заказчики" }
      ]
    });
    this.updateData();

    if (this.props.companyId) {
      const search = "";
      this.props.getAllCustomers({ companyId: this.props.companyId, search });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.customers !== this.props.customers ||
      prevProps.filters !== this.props.filters
    ) {
      this.updateData();
    }

    if (this.props.companyId !== prevProps.companyId) {
      const search = "";
      this.props.getAllCustomers({ companyId: this.props.companyId, search });
    }
  }

  updateData = () => {
    if (this.props.customers) {
      const customers =
        this.props.filters.typeList && this.props.filters.typeList !== "all"
          ? this.props.customers.filter(
              item =>
                item.status &&
                item.status.profileStatusKey === this.props.filters.typeList
            )
          : this.props.customers;

      let markers = [];
      customers.forEach(item => {
        if (item.map) {
          markers.push(item.map);
        }
      });
      this.setState({
        customers,
        markers
      });
    }
  };

  onChangeTypeList = e => {
    let statusCustomer = e.target.value;
    this.props.changeTypeListCustomers(statusCustomer);
  };

  onChangeSearch = e => {
    const { value } = e.target;
    this.getAllCustomersDebounced({
      companyId: this.props.companyId,
      search: value
    });
  };

  onChangeTable = (pagination, filters, sorter, extra) => {
    const companyId = this.props.companyId;
    let sort = {};

    if (sorter.column) {
      let order = "desc";
      let key = sorter.column.key;

      if (sorter.order === "ascend") {
        order = "asc";
      }

      if (key === "customer") {
        key = "name_legal";
      }

      if (key === "data") {
        key = "updated_at";
      }

      sort["sort[" + key + "]"] = order;

      this.props.getAllCustomers({ companyId, search: "", sort });
    }
  };

  prettyRubl = value => {
    return String(value).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ") + " ₽";
  };

  formatName = (name, subject = null) => {
    if (subject !== "physical") {
      return name;
    } else {
      let str = "";
      if (name.lastname) {
        str += name.lastname[0].toUpperCase() + name.lastname.slice(1) + " ";
      }
      if (name.name) {
        str += name.name[0].toUpperCase() + ".";
      }
      if (name.patronymic) {
        str += name.patronymic[0].toUpperCase() + ".";
      }
      return str !== "" ? str : " - ";
    }
  };

  renderColumns = () => {
    const { drawerCols: columns } = this.state;
    const filteredCols = [];
    let cols = [
      {
        title: "Наименование",
        dataIndex: "customer",
        key: "customer",
        width: "15%",
        render: customer => (
          <div className="photoColumn">
            <Avatar
              shape="square"
              size="large"
              src={customer.photo || EmployeeImage}
              icon="user"
            />
            <span id="columnHeader">
              <span className="columnHeader__title">
                {customer && customer.nameLegal
                  ? this.formatName(customer.nameLegal)
                  : customer.subjectKey === "physical"
                  ? this.formatName(customer, "physical")
                  : " - "}
              </span>
              <br />
              {customer.subject.subjectKey === "physical" && !customer.inn && (
                <Text type="secondary">
                  {customer && customer.subject ? customer.subject : ""}
                </Text>
              )}
              <Text type="secondary">{customer.inn && customer.inn}</Text>
            </span>
          </div>
        ),
        sorter: true
      },
      {
        title: "Ответственный",
        dataIndex: "responsible",
        key: "responsible",
        width: "10%",
        render: responsible => (
          <span id="columnHeader">
            {responsible.name}
            <br />
            <Text type="secondary">{responsible.position}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return a.responsible.name.localeCompare(b.responsible.name);
        }
      },
      {
        title: "Дата изменения",
        dataIndex: "data",
        key: "data",
        width: "15%",
        render: data => (
          <span id="columnHeader">
            {data.changed
              ? moment(new Date(data.changed)).format("DD.MM.YYYY")
              : "Не известно"}
            <br />
            <Text type="secondary">
              Создан:{" "}
              {data.created
                ? moment(new Date(data.created)).format("DD.MM.YYYY")
                : "Не известно"}
            </Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Заказы",
        dataIndex: "orders",
        key: "orders",
        width: "15%",
        render: orders => (
          <span id="columnHeader">
            Выполненые: {orders.completed}
            <br />
            <Text type="secondary">Готов к вып.: {orders.readyToRun}</Text>
          </span>
        )
      }
    ];
    for (let [key, value] of Object.entries(columns)) {
      cols.forEach(col =>
        col.key === key && value === true ? filteredCols.push(col) : null
      );
    }

    return filteredCols;
  };

  handleClickRow = (row, index) => {
    return {
      onClick: () => {
        this.props.history.push(`/customers/${row.profileId}`);
      }
    };
  };

  changePaginationSize = e => {
    this.setState(() => ({
      pagination: {
        pages: Number(e)
      }
    }));
  };

  render() {
    const { pagination, customers } = this.state;
    return (
      <div className="basicForm" id="customersPartners">
        <div className="customersTableHeader">
          <Link to={{ pathname: "/" + ADD_CUSTOMER }}>
            <Button type="primary" id="add_customer">
              Добавить заказчика
            </Button>
          </Link>
        </div>
        <div id="customersWrapper">
          <TopPanel
            typesList={this.props.customerTypes}
            stat={this.props.customersStat}
            totalCustomers={
              this.props.customers ? this.props.customers.length : 0
            }
            onChangeTypeList={this.onChangeTypeList}
            onChangeSearch={this.onChangeSearch}
          />
          <CustomersTable
            rowKey={"profileId"}
            renderColumns={this.renderColumns}
            tableColumnsLen={this.state.tableColumnsLen}
            customers={customers}
            pages={pagination.pages}
            customersLoading={this.props.customersLoading}
            changePaginationSize={this.changePaginationSize}
            onChangeTable={this.onChangeTable}
            handleClickRow={this.handleClickRow}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const { customers, filters } = state.Customers;
    return {
      customersLoading: customers.customersLoading,
      customers:
        filters.count > 0 ? customers.filterCustomers : customers.allCustomers,
      customersStat:
        filters.count > 0
          ? customers.filterCustomersStat
          : customers.customersStat,
      customerTypes: customers.customerTypes,
      filters,
      companyId: state.Authorization.activeProfile.companyId
    };
  },
  {
    setCaption,
    getAllCustomers,
    updateFilterFieldsCustomers,
    searchCustomers,
    resetFiltersCustomers,
    changeTypeListCustomers
  }
)(Customers);
